module.exports = __webpack_public_path__ + "img/manda_017.11565704.png";